import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { Button, Typography } from '@popmenu/common-ui';

import { formatPhone } from '../../utils/utils';
import { notBlankValidator } from '../../utils/forms';
import { currentSessionShape, withCurrentSession } from '../CurrentSessionProvider';
import confirmSessionAuthyMutation from '../../libs/gql/mutations/users/confirmSessionAuthyMutation.gql';
import enableUserAuthyMutation from '../../libs/gql/mutations/users/enableUserAuthyMutation.gql';
import sendUserAuthyCodeMutation from '../../libs/gql/mutations/users/sendUserAuthyCodeMutation.gql';

import BasicForm, { SubmitGroup, TextFieldGroup } from '../../admin/shared/forms/BasicForm';
import Grid from '../Grid';
import Mutation from '../Mutation';
import SignOutButton from '../SignOutButton';
import { AH, AHLevelProvider } from '../../consumer/shared/AccessibleHeading';

class AuthyForm extends React.PureComponent {
  render() {
    const session = this.props.currentSession;
    const { user } = session;
    const authyApp = (
      <a href="https://authy.com/download/" rel="noreferrer" target="_blank">
        <FormattedMessage
          defaultMessage="Authy app"
        />
      </a>
    );
    if (user && user.authyStatus === 'authy_disabled') {
      return (
        <React.Fragment>
          <AH typography align="center" gutterBottom variant="h6">
            <strong>
              <FormattedMessage
                defaultMessage="Enable Multi-Factor Authentication"
              />
            </strong>
          </AH>
          <AHLevelProvider>
            <Typography align="center" gutterBottom>
              <FormattedMessage
                defaultMessage="Multi-factor authentication is currently disabled. Confirm your mobile phone and password to secure your Popmenu account."
              />
              <br /><br />
              <FormattedMessage
                defaultMessage="Enter the security code sent to your mobile phone or {authyApp}."
                values={{ authyApp }}
              />
              <br /><br />
              <a href="https://authy.com/what-is-2fa/" rel="noreferrer" target="_blank">
                <FormattedMessage
                  defaultMessage="What is MFA?"
                />
              </a>
              <br /><br />
            </Typography>
            <BasicForm
              defaultValues={{
                email: user.email,
                phone: formatPhone(user.phone),
                userId: user.id,
              }}
              mutate={{
                mutation: enableUserAuthyMutation,
                toVariables: ({ email, ...variables }) => variables,
              }}
            >
              <TextFieldGroup
                disabled
                field="email"
                title="Email"
              />
              <TextFieldGroup
                field="phone"
                title="Mobile Phone"
                type="tel"
                validate={notBlankValidator}
              />
              <TextFieldGroup
                field="password"
                title="Current Password"
                type="password"
                validate={notBlankValidator}
              />
              <SubmitGroup
                block
                size="lg"
                title="Send Code"
              />
            </BasicForm>
            <Typography align="center">
              <SignOutButton isAdmin />
            </Typography>
          </AHLevelProvider>
        </React.Fragment>
      );
    }
    if (user && (user.authyStatus === 'authy_pending' || !session.isAuthyVerified)) {
      return (
        <React.Fragment>
          <AH typography align="center" gutterBottom variant="h6">
            <strong>
              <FormattedMessage
                defaultMessage="Confirm Multi-Factor Authentication"
              />
            </strong>
          </AH>
          <AHLevelProvider>
            <Typography align="center" gutterBottom>
              <FormattedMessage
                defaultMessage="Enter the security code sent to your mobile phone or {authyApp}."
                values={{ authyApp }}
              />
              <br /><br />
            </Typography>
            <BasicForm mutation={confirmSessionAuthyMutation}>
              <TextFieldGroup
                autoComplete="one-time-code"
                field="authyCode"
                title="Code"
                validate={notBlankValidator}
              />
              <SubmitGroup
                block
                size="lg"
                title="Confirm"
              />
            </BasicForm>
            <Grid container justifyContent="center">
              <Grid item>
                <Mutation mutation={sendUserAuthyCodeMutation}>
                  {(sendUserAuthyCode, { loading }) => (
                    <Button
                      loading={loading}
                      onClick={() => {
                        if (loading) {
                          return;
                        }
                        sendUserAuthyCode({ variables: { userId: user.id } });
                      }}
                      variant="text"
                    >
                      <FormattedMessage
                        defaultMessage="Send Another Code"
                      />
                    </Button>
                  )}
                </Mutation>
              </Grid>
            </Grid>
            <Typography align="center">
              <SignOutButton isAdmin />
            </Typography>
          </AHLevelProvider>
        </React.Fragment>
      );
    }
    return <Redirect to="/" />;
  }
}

AuthyForm.propTypes = {
  currentSession: currentSessionShape.isRequired,
};

export default withCurrentSession(AuthyForm);
